export const sv = {
    admin: {
        user: 'Display för kundläge',
        userModeDescription:
            'Genom att aktivera detta läge kommer sidan att förhandsvises sådan som den presenteras för kunder.', // må oversettes bedre
    },
    app: {
        forvalter: 'Dashbord för fastigheter',
        mittleieforhold: 'Min lokal',
        openInSuperOffice: 'SuperOffice',
        verified: 'Verified',
        dynamics365: 'Dynamics 365',
        eiendomGpt: 'EiendomGPT',
    },
    auth: {
        authorizing: 'Loggar in...',
        loggingOut: 'Loggar ut...',
        login: 'Logga in',
        logout: 'Logga ut',
        // eslint:disable-next-line: max-line-length
        privacyDescription:
            'Genom att använda denna webbplats samtycker du till att vi samlar in information som används för att förbättra användarupplevelsen för användarna av denna webbplats. Läs mer om integritet på vår ', // må oversettes
        privacyLinkTitle: 'sekretesssida',
        sessionTimeout: 'Din session har gått ut',
        sessionTimeoutLoginAgain: 'Logga in igen',
    },
    breadcrumbs: {
        availibleArea: 'Fritt Areal',
        building: 'Fastighet',
        byggUtleie: 'Uthyrning',
        contractManagement: 'Kontraktshantering',
        checkOff: 'Kolla upp',
        expiringArea: 'Kontraktets utgång',
        dashboard: 'Min lokal',
        invoice: 'Faktura',
        listUsers: 'Användare',
        message: 'Anslagstavla',
        registerUser: 'Registrera användare',
        reports: 'Rapporter',
        searchUsers: 'Sök efter användare',
        selectClient: 'Välj kundrelation',
        supportApplicationForm: 'Ansökan om stöd',
        ticket: 'Saker',
        forvaltningsplan: 'Förvaltningsplan',
        environmentProfile: 'Miljöprofil',
        keyFigures: {
            area: 'Område nyckeltal',
            economy: 'Ekonomi nyckeltal',
        },
        project: {
            report: 'Projektrapport',
            schema: 'Projektschema',
        },
        leverandor: {
            schema: 'Leverandörskjema',
            documentation: 'Dokumentation',
            leverandorReport: 'Leverantörrapport',
        },
    },
    bygg: {
        favoritt: 'Lägg till favorit',
        removeFavorite: 'Ta bort favorit',
        noBuildingsYet:
            'Du har inga byggnader än, men du kan lägga till byggnader i favoritlistan via sökfältet i toppmenyn.',
        myBuildings: 'Mina byggnader',
        settings: {
            title: 'Inställningar',
            saveChanges: 'Spara ändringar',
            showByggGrunn: 'Visa tomt i översikt över byggnader',
        },
    },
    chat: {
        tooltip: 'Chatta med dashbord för fastigheter om kontrakt',
    },
    comments: {
        title: 'Kommentarer: {{page}}',
        tooltip: 'Kommentarer',
        datePickerLabel: 'Välj år',
        chooseYearDescription: 'Välj vilket år kommentaren gäller',
        newComment: 'Ny kommentar',
        editComment: 'Redigera kommentar',
        edit: 'Redigera',
        delete: 'Radera',
        highlight: 'Markera',
        readMore: 'Läs mer',
        resetHighlightsFrontpage: 'Återställ markeringar på förstasidan',
        close: 'Stäng',
        pin: 'Fäst',
        titleLabel: 'Titel',
        validation: {
            titleTooLong: 'Titeln kan inte vara längre än 50 tecken',
            titleOutOfRange:
                'Titeln får inte vara kortare än 1 tecken eller längre än 50 tecken',
        },
        seeDetails: 'Se detaljer',
        updatedBy: 'Uppdaterad av: ',
        edited: 'Senast redigerad: ',
        published: 'Publicerad: ',
    },
    editor: {
        paragraph: 'Stycke',
        heading1: 'Rubrik 1',
        heading2: 'Rubrik 2',
        heading3: 'Rubrik 3',
        heading4: 'Rubrik 4',
        heading5: 'Rubrik 5',
        heading6: 'Rubrik 6',
        horizontalRule: 'Horisontell linje',
        insertTable: 'Infoga tabell',
        loadingEditor: 'Laddar editor...',
        addColumnBefore: 'Ny kolumn före',
        addColumnAfter: 'Ny kolumn efter',
        deleteColumn: 'Ta bort kolumn',
        addRowBefore: 'Ny rad före',
        addRowAfter: 'Ny rad efter',
        deleteRow: 'Ta bort rad',
        deleteTable: 'Ta bort tabell',
    },
    contractFrame: {
        externalFrame: {
            actionButton: 'Öppen kontraktshantering',
            contractNotFoundDescription:
                'Du hittar alla dina aktuella hyresvillkor under den respektive fastighet.',
            contractNotFoundLink: 'Gå till mina fastigheter',
            contractNotFoundTitle: 'Letar du efter dina hyresvillkor?',
            manualContractDescription:
                'Du kan få en kopia av dina kontrakt genom att kontakta din fastighetsskötare på KLP.',
            manualContractTitle: 'Letar du efter ett befintligt PDF-kontrakt?',
            description:
                'För att öppna den digitala kontraktsförhandlingen behöver vi använda en ny flik.',
            description2:
                'Tryck på knappen nedan så öppnar vi kontraktsförhandlingen åt dig i en ny separat flik.',
            title: 'Ska du skriva under eller förhandla om ett nytt digitalt kontrakt?',
        },
    },
    dxboFrame: {
        externalFrame: {
            actionButton: 'Öppna projekt',
            description: 'För att öppna projekt måste vi använda en ny flik',
            title: 'Projekt måste öppnas i en ny flik',
        },
    },
    environment: {
        // tslint:disable-next-line: max-line-length
        description:
            'Den här tjänsten kan vara instabil under vissa perioder. Vi utvecklar och förbättrar det kontinuerligt och vi uppskattar mycket all din feedback och förslag.',
        dev: 'DEV',
        environment: 'Miljö: ',
        title: 'Miljö',
        miljoprofil: 'Byggnadens miljöprofil',
        powerBi: 'Miljörapport',
        noContextSelected:
            'Du måste leta upp en byggnadsavdelning innan du kan se detta',
        local: 'LOCAL',
        test: 'TESTA',
    },
    faktura: {
        payments: 'Betalningar',
    },
    file: {
        deleting_1: 'Tar bort filen...',
        deleting: 'Tar bort filene...',
        downloading: 'Laddar ner...',
        downloadingFinished: 'Nedladdning slutförd',
        fileNotFound: 'Filen finns inte',
        preview: 'Förhandsvisning',
        previewDownload: 'Förhandsvisning    / Ladda ner',
        downloadFailed: 'Nedladdningen misslyckades',
        saving_1: 'Sparar filen...',
        saving: 'Sparar filene...',
        selectFiles_0: 'Välj fil',
        selectFiles: 'Välj filer',
    },
    availableArea: {
        availableArea: 'Fritt areal',
        availableAreaValue: 'Fritt marknadsvärde',
        downloadSourceData: 'Ladda ner tillgängliga lokaler för Excel',
        filedownloadname: 'Fritt_Areal{{lastname}}{{region}}.xlsx',
        potentialRevenue: 'Marknadsvärde fritt areal',
        totalArea: 'Totalareal',
        table: {
            areaType: 'TYPE',
            buildingAddress: 'ADRESS',
            buildingNo: 'NR.',
            floor: 'ETASJE',
            leaseObject: 'HYRESOBJEKT',
            leaseObjectId: 'HYRESOBJEKT Id',
            markedsprisLedigAreal: 'MARKNADSVÄRDE (NOK)',
            markedsprisPerM2: 'ENHETSPRIS',
            physicalArea: 'AREAL',
            property: 'EGENDOM',
            plotId: 'GRUNNID',
            roomNo: 'ZON NR',
            noMatch:
                'Vi hittade inga lediga lokaler för byggnadsavdelningen{{buildingName}} och / eller portföljen du har valt',
        },
    },
    expiringContracts: {
        expirationProfile: {},
        keyFigures: {
            availableArea: 'Fritt areal',
            availableAreaValue: 'Tillgängligt marknadsvärde',
        },
        table: {
            amountYear: 'ÅRSPRIS',
            area: 'AREAL',
            areaType: 'TYPE',
            contractHeadExpiryDate: 'UTGÅNG',
            contractLineExpiryDate: 'LINJEUTGÅNG',
            contractNumber: 'KONTRAKT',
            customerName: 'KUNDE',
            customerNumber: 'KUNDENUMMER',
            description: 'BESKRIVNING',
            filterReset: 'Ta bort filtret',
            filterTitle: 'Filtre:',
            noMatch:
                'Vi hittade inga utgående kontrakt för byggnadsavdelningen{{buildingName}} och / eller portföljen du har valt',
            pricePerAmount: 'NOK/STK',
            pricePerSquareMeter: 'NOK/m²',
            pricePerUnit: 'ENHETSPRIS',
            property: 'EGENDOM',
            sortingWeight: 'PRIORITET',
            sortingWeightChipText: 'Prioritet',
        },
        downloadSourceData: 'Ladda ner kontrakt som löper ut till Excel',
        filedownloadname:
            'Utgående_kontrakt{{lastname}}{{region}}{{from}}{{to}}.xlsx',
    },
    checkOffContract: {
        title: 'Kontrakt {{kontraktnavn}}',
        signed: 'Signerad: ',
        sender: 'Avsändare: ',
        noSender: 'Ingen avsändare',
        subTitle: '{{kundeNavn}} ({{kundeNummer}})',
        tableDescription:
            'Registrerade kontraktslinjer för {{kundeNavn}} ({{kundeNummer}})',
        receivers: 'Mottagare:',
        noReceivers: 'Inga undertecknare.',
        noDocuments: 'Inga dokument har laddats upp för detta kontrakt.',
        subTitlePartTwo: 'för kund',
        subTitlePartThree: 'till D365 kontraktslinjer?',
        saveButton: 'Spara',
        saveButtonCompletedStep: 'Dela Min lokal',
        cancelButton: 'Avbryt',
        backButton: 'Tillbaka till registreringsöversikten',
        document: 'Dokument:',
        missingDocument:
            'Tyvärr är detta dokument inte tillgängligt för nedladdning och visning',
        registerInD365: 'Registrera kontrakt i D365:',
        registreringProsessLink: 'Gå till registrering för: {{type}}',
        processHeader: {
            Kontrakt: 'Registrera kontrakt i D365:',
            Garanti: 'Registrera garanti',
            Innflytningsprotokoll: 'Registrera innflytting',
            Utflytningsprotokoll: 'Registrera utflytting',
        },
        error: 'Ett fel inträffade under hämtning av kontraktsdokument. Vänligen försök igen senare.',
        tooltip:
            'Knappen är deaktiverad eftersom föregående steg inte är fullført, eller för att nuvarande steg redan har slutförts.',
        tooltipSendButton:
            'Knappen är deaktiverad eftersom kontraktsdokumentet saknar kontraktslinjer.',
        shareButtonCompleted: 'Ändre delning till Min lokal',
        shareButton: 'Dela Min lokal',
        startRegistrationButton: 'Starta registrering',
        successfulSending: 'Kontraktsdokumentet har delats.',
        shareDocumentHeading: 'Dela kontraktsdokument - {{kontraktnavn}}',
        secondaryTitle:
            'Koppla kontraktdokument för {{kundeNavn}} ({{kundeNummer}}) til registrerade kontraktslinjer',
        shareDocumentWarning:
            'NB! Dela endast kontraktshandlingen som redan är registrerad i D365',
        dialog: {
            title: 'Är du säker på att du vill tilldela till den valda konsulten?',
            stepCompletion: 'Är du säker på att du vill slutföra steget?',
        },
        notStartedActivity: 'Uppgiften har inte påbörjats.',
        insufficientUserRole:
            "Uppgiften kräver rollen(e) '{{role}}', du är inte tilldelad denna roll.",
        completedActivity: 'Uppgiften ble utførs av: {{name}}, {{date}}',
        adminInformation:
            "Uppgiften kräver rollen '{{role}}' och är tilldelad '{{assigned}}'. Du har admin-roll och kan ändra/utföra uppgiften.",
        roles: {
            Forvalter: 'Förvaltare',
            Okonomi: 'Ekonomi',
            QAOkonomi: 'Ekonomi QA',
        },
        step: {
            // Vurder relevans
            Activity_1vr6y7a: {
                title: 'Bedöm relevans',
                secondaryTitle: 'Är dokumentet relevant för registrering?',
                description:
                    'Inte alla dokument från Verified ska registreras. Välj «Relevant» om dokumentet är ett kontrakt, ett inflyttningsprotokoll eller ett utflyttningsprotokoll, och välj sedan dokumenttyp. Välj «Inte relevant» om dokumentet inte är något av dessa, eller inte är relevant.',
                notRelevantButton: 'Inte relevant',
                relevantButton: 'Relevant',
                cta: 'Slutför steget',
                completeButton: 'Slutför',
                completedBy: 'Utførs av: {{name}}, {{date}}',
            },
            // Tildel økonomikonsulent
            Activity_1rdcqtp: {
                title: 'Tilldela finansiell konsult',
                secondaryTitle: 'Välj finansiell konsult',
                tertiaryTitle: 'Välj konsult',
                descriptionPartOne:
                    'Vi har valt byggnadens ekonomikonsult åt dig.',
                descriptionPartTwo:
                    'Om du behöver ändra detta kan du göra det här.',
                cta: 'Tilldela ',
                chosenConsultant: 'Vald konsult:',
                completedBy: 'Utførs av: {{name}}, {{date}}',
            },
            sendToRegistration: {
                title: 'Skicka för registrering',
                secondaryTitle: 'Registrering i Dynamics 365',
                descriptionPartOne:
                    'Vi har skickat ett meddelande till {{navn}} som kommer att registrera kontraktet i D365.',
                descriptionPartTwo:
                    'Du får ett meddelande när kontraktet är registrerat.',
                cta: 'Slutför steget',
                completedBy: 'Utførs av: {{name}}, {{date}}',
            },
            // Utfør registrering i D365
            Activity_0hw9rg3: {
                title: 'Registrera i D365',
                secondaryTitle: 'Registrering i Dynamics 365',
                tertiaryTitle: 'Välj konsult',
                levendeKontrakterDescription:
                    'Baserat på information från Levende Kontrakter har vi skapat ett utkast för en ny kund, {{kundeNavn}}, och ett utkast för registrering av detta nya kontrakt ({{kundeNummer}}) till Onsite 365.',
                description:
                    'Kontrollera innehållet i utkastet och slutför registreringen.',
                goToCustomer: 'Gå till kund',
                goToContractDraft: 'Gå till kontrakt',
                goToLevendeKontrakter: 'Gå till Levende Kontrakter',
                errorStatusNewCustomer: 'Det gick inte att skapa en ny kund',
                errorStatusNewContractDraft:
                    'Det gick inte att skapa ett nytt kontrakt',
                D365Button: 'Öppna Onsite365',
                cta: 'Slutför steget',
                completeButton: 'Slutför',
                selectController: 'Välj controller för registrering',
                chosenConsultant: 'Vald konsult:',
                completedBy: 'Utførs av: {{name}}, {{date}}',
            },
            // Kontroll av registrering i D365
            Activity_1bk3epl: {
                title: 'Kontroll av registrering i D365',
                descriptionPartOne:
                    'Om kontraktet är korrekt registrerat i D365 kan det godkännas.',
                approveRegistrationButton: 'Godkänn registrering',
                cta: 'Slutför steget',
                controlRegistration: 'kontrollera registrerat kontrakt',
                goToCustomer: 'Gå till kund',
                goToContractDraft: 'Gå till kontrakt',
                goToLevendeKontrakter: 'Gå till Levende Kontrakter',
                D365Button: 'Öppna Onsite365',

                completedBy: 'Utførs av: {{name}}, {{date}}',
            },
            notifyManager: {
                title: 'Meddela förvaltaren',
            },
            // Vurder gjennomgangsmøte
            Activity_1b84rij: {
                title: 'Överväg granskningsmöte',
                description:
                    'Om det är ett större kontrakt kan det bli aktuellt med ett möte med förvaltaren.',
                reviewMeetingButton: 'Granskningsmöte',
                continueButton: 'Fortsätt',
                cta: 'Slutför steget',
                completedBy: 'Utførs av: {{name}}, {{date}}',
            },
            // Gjennomgangsmøte
            Activity_1m3ak5n: {
                title: 'Granskningsmöte',
                descriptionPartOne:
                    'Finans har nu registrerat kontraktet i D365 och vill gärna ha ett granskningsmöte.',
                descriptionPartTwo:
                    'Förbered mötet genom att gå igenom fakturautkastet till kunden.',
                previewButton: 'Förhandsgranska faktura',
                approveRegistrationButton: 'Godkänn registrering',
                cta: 'Slutför steget',
                completedBy: 'Utførs av: {{name}}, {{date}}',
            },
            // Oppdater kundenummer i SuperOffice
            Activity_057tcgr: {
                title: 'Uppdatera kundnummer i SuperOffice',
                descriptionPartOne:
                    'Klicka på denna länk för att uppdatera kundnummeret.',
                descriptionPartTwo:
                    'Om kundnummer är korrekt registrerat kan du slutföra det aktuella steget och fortsätta registreringen.',

                descriptionPartThree:
                    'Detta krävs för att se översikt över kontraktsrader för kontraktdokumentet.',
                cta: 'Slutför steg',
                goToSuperOffice: 'Gå till SuperOffice',
                completedBy: 'Utfört av: {{name}}, {{date}}',
            },
            // Knytt dokument og linje
            Activity_15vq4i6: {
                title: 'Länka dokument och rad',
                secondaryTitle:
                    'Registrerade kontraktslinjer för {{kundeNavn}} ({{kundeNummer}})',
                table: {
                    validToDate: 'TILL',
                    validFromDate: 'FRÅN',
                    amount: 'ANTALL',
                    areal: 'AREAL',
                    yearlyPrice: 'NOK/ÅR',
                    kontraktId: 'KONTRAKTSNUMMER',
                    id: 'ID',
                    name: 'NAMN',
                    choose: 'VÄLJ',
                    noRelevantContractLines:
                        'Vi hittade inga relevanta kontraktslinjer för kunden inom signeringsperioden.',
                },
                cta: 'Slutför steget',
                completedBy: 'Utførs av: {{name}}, {{date}}',
            },
            complete: {
                title: 'Slutför',
                secondaryTitle: 'Registreringssammanfattning',
                table: {
                    tenant: 'Hyresgäst',
                    area: 'Areal',
                    leaseStart: 'Hyresstart',
                    invoiceAmount: 'Fakturabelopp',
                    property: 'Fastighet',
                    parking: 'Parkering',
                    endOfLease: 'Hyreskontraktets slut',
                    invoiceDate: 'Fakturadatum',
                },
                completeRegistration: 'Slutför registreringen',
                cancel: 'Avbryt',
                completedBy: 'Utførs av: {{name}}, {{date}}',
            },
        },
        table: {
            validToDate: 'TILL',
            validFromDate: 'FRÅN',
            amount: 'ANTALL',
            areal: 'AREAL',
            yearlyPrice: 'NOK/ÅR',
            kontraktId: 'KONTRAKTSNUMMER',
            kontraktLinjeIds: 'ID',
            name: 'NAMN',
            choose: 'VÄLJ',
            noRelevantContractLines:
                'Vi hittade inga relevanta kontraktslinjer för kunden inom signeringsperioden.',
        },
    },
    contractRegistration: {
        oppslag: {
            sokLabel: 'Sök (kundnamn eller kundnummer)',
            sokUtenFiltre:
                'Söker i alla kontrakt. Andra filter är avstängda vid sökning.',
        },
        contractTypes: {
            Kontrakt: 'Kontrakt',
            Garanti: 'Garanti',
            Innflytningsprotokoll: 'Inflyttning',
            Utflytningsprotokoll: 'Utflyttning',
        },
        statuses: {
            checkedOff: 'Kollade upp',
            notCheckedOff: 'Inte kollade upp',
            new: 'Ny',
            shallNotBeRegistered: 'Ska inte registreras',
            withForvalter: 'Med manager',
            assignedFinance: 'Tilldelad ekonomi',
            registrationD365: 'Registrering D365',
            forApporval: 'Till godkännande',
            toQA: 'Till QA',
            QACompleted: 'QA slutförd',
            approved: 'Godkänd',
            completed: 'Avslutad',
            RegistreringAvGaranti: 'Garantiregistrering',
        },
        table: {
            actionMenuItems: {
                restartProcess: 'Starta om processen',
                showDetails: 'Se detaljer',
                assignFinancePerson: 'Tilldela eko. resp.',
                download: 'Ladda ner',
                notRelevant: 'Inte relevant',
            },
            statusCode: {
                title: 'STATUS',
                warning: 'Vi hittar ingen registrering i SuperOffice',
                noPropertyWarning:
                    'Vi hittar ingen information om fastigheten i detta kontrakt. En vanlig orsak är att dokumentet i SuperOffice inte är kopplat till ett projekt eller en försäljning.',
                noEconomyWarning:
                    'Vi kan inte hitta fastighetens ekonomichef. En vanlig orsak är att dokumentet i SuperOffice inte är kopplat till ett projekt eller en försäljning.',
                noTenantWarning:
                    'Vi hittar ingen hyresgäst på detta kontrakt. En vanlig orsak är att dokumentet skapades i Verified och inte i SuperOffice eller att kontakten inte skapades.',
            },
            contracts: {
                statusCode: {
                    success: 'Vi har hittat en ny registrering för denna kund',
                    foundMultiple:
                        'Vi har hittat flera nya registreringar på denna kund inom 14 dagar efter undertecknandet. Dubbelkolla med ekonomichefen att detta kontrakt är registrerat',
                    foundMultipleWithCount:
                        'Vi har hittat {{count}} nya registreringar på den här kunden inom 14 dagar efter undertecknandet. Dubbelkolla med ekonomichefen att detta kontrakt är ett av dessa.',
                    notFound: 'Vi kan inte hitta någon information.',
                    error200:
                        'Vi kunde inte hitta några mottagare för dokumentet i Verified eller Superoffice.',
                    error302:
                        'Vi kan inte hitta kundnummer. Kundnummer kan vara felaktigt i Superoffice eller så finns det inga kontakter som matchar mottagarna.',
                    error300:
                        'Vi kan inte hitta en match med ett kontrakt. Antingen är kontraktet inte undertecknat ännu eller så har det precis undertecknats. Det kan ta upp till 14 dagar från undertecknandet innan det är synligt.',
                    error303:
                        'Vi hittar inga matchningar på kontrakt. Om det har gått mer än 14 dagar mellan signering och registrering, kommer det inte att visas här. Du kan kontakta ekonomichefen för mer information.',
                    error301: 'Vi kan inte hitta byggnadsnumret.',
                    error100:
                        'Vi kan inte hitta en referens till dokumentet. Dokumentet är inte registrerat via Verified eller Superoffice, utan har laddats upp till Superoffice.',
                },
            },
            checkOff: 'KOLLA UPP',
            contractDocument: 'DOKUMENT',
            economyPerson: 'EKONOMI',
            property: 'EGENDOM',
            propertyManager: 'FÖRVALTARE',
            registeredDate: 'Registrerad D365',
            signDate: 'SIGNERAD',
            tenant: 'HYRESGÄST',
            kundeNummer: 'KUNDNUMMER',
            action: 'HANDLING',
            type: 'TYP',
            email: {
                helpTextForvalter: 'Skicka mail till byggnadens förvaltare',
                helpTextOkonomi: 'Skicka ett mail till byggnadens ekonomichef',
                subjectText: 'Registrering av kontrakt i ',
            },
            emptyTableMessage:
                'Vi kan inte hitta några kontrakt för byggnadsavdelningen och / eller portföljen du har valt.',
        },
        title: 'D365 registreringsuppföljning',
        notification: 'Bearbeta begäran. Vänta..',
        error: 'Ett fel inträffade. Försök igen senare.',
        errorSaveForm: 'Ett fel uppstod när schemainnehållet skulle sparas.',
        successfulRegistration: 'Kontraktsdokumentet har registrerats.',
        successfulOperation: 'Tiltaket har utförts.',
        newProcess: 'Nya dokument',
        ongoingProcessForvalter: 'Hos förvaltare',
        ongoingProcessFinance: 'Hos ekonomi',
    },
    contractManagement: {
        leko: 'Förhandling',
        negotiation: 'Förhandling',
        overview: 'Kontrakter',
        registrer: 'Registrering',
        sign: 'Signering',
        title: 'Kontrakthantering',
        ongoingProcesses: 'Pågående processer',
        forSigning: 'För signering',
        forRegistration: 'För registrering',
    },
    contract: {
        amountYear: 'Kr/år',
        area: 'Areal',
        chartTitle: 'Förfalloprofil:',
        contractExpiry: 'Utgång',
        customerName: 'Kund',
        expiringArea: 'Utgående areal',
        expiringContracts: 'Utgående kontrakter',
        expiringContractValue: 'Utgående hyresintäkt',
        expiringLines:
            '{{contractCount}} kontraktslinjer löper ut mellan {{from}} och {{to}}:',
        expiry: {
            expired: 'Har löpt ut',
            expires_within_1y: 'Går ut inom 1 år',
            expires_within_2y: 'Går ut inom 2 år',
            expires_within_3y: 'Går ut inom 3 år',
            expires_within_4y: 'Går ut inom 4 år',
            expires_within_6m: 'Går ut inom 6 mnd',
            eternal: 'Inget utgångsdatum',
        },
        expiryProfileTime: {
            expired: 'Förfalloprofil (har löpt ut):',
            expires_within_6m: 'Förfalloprofil (6 månader):',
            expires_within_1y: 'Förfalloprofil (1. år):',
            expires_within_2y: 'Förfalloprofil (2 år):',
            expires_within_3y: 'Förfalloprofil (3 år):',
            expires_within_4y: 'Förfalloprofil (4 år):',
            eternal: 'Förfalloprofil (Inget utgångsdatum):',
        },
        keyFiguresTime: {
            expired: 'Nyckeltal (Utgånget):',
            expires_within_6m: 'Nyckeltal (6 mnd):',
            expires_within_1y: 'Nyckeltal (1. år):',
            expires_within_2y: 'Nyckeltal (2 år):',
            expires_within_3y: 'Nyckeltal (3 år):',
            expires_within_4y: 'Nyckeltal (4 år):',
            eternal: 'Nyckeltal (Inget utgångsdatum)',
        },
        expiryRateNOK: 'Utgånsgrad (NOK)',
        income: 'Hyresintäkt',
        keyFigures: 'Nyckeltal ({{date}}):',
        leasedArea: 'Hyrt areal',
        lineExpiry: 'Detaljutgång',
        lineName: 'Beskrivning',
        number: 'Kontrakt Nr.',
        pcs: 'stk',
        portfolioComposition: 'Portföljsammansättning:',
        property: 'Egendom',
        rentalStatusPerDate: 'Hyresstatus ({{date}}):',
        selectExpiry: 'Välj  utgång',
        sortingWeight: ' ',
        title: 'Kontrakt',
        totalArea: 'Totalareal',
        totalPotentialIncome: 'Total potentiell hyra',
    },
    ledigAreal: {
        keyFigures: {
            areaAvailable: 'Fritt areal',
            areaLeased: 'Hyrt areal',
            availableAreaValue: 'Marknadsvärde',
            rentalIncome: 'Hyresintäkt',
            totalArea: 'Totalareal',
            totalPotentialIncome: 'Total potentiell hyra',
        },
        areaAvailable: 'Fritt areal',
        areaLeased: 'Hyrt areal',
        areaRatio: 'Arealmessig utlejegrad',
        areaToExpire: 'Utgående areal',
        areaType: 'Type',
        buildingAddress: 'Adress',
        buildingNo: 'Nr.',
        floor: 'Etasje',
        leaseObject: 'Hyresobjekt',
        leaseObjectId: 'Hyresobjekt Id',
        markedsprisLedigAreal: 'Marknadsvärde (NOK)',
        markedsprisPerM2: 'NOK/m²',
        physicalArea: 'Areal',
        plotId: 'GrunnID',
        property: 'Egendom',
        roomNo: 'Zon Nr',
        section: 'Sektion',
        title: '{{count}} lokalerna är lediga',
    },
    portfolio: {
        all: 'Alla portföljer',
        select: 'Välj portfölj',
    },
    region: {
        all: 'Alla regioner',
        select: 'Välj region',
    },
    filterPanel: {
        nullstill: 'Återställ',
        alle: 'Alla',
        portefolje: 'Portfölj',
        region: 'Region',
        status: 'Status',
        endretEtter: 'Ändrad efter',
        signertEtter: 'Signerad efter',
        antall: 'Max antal',
        tomFelt: 'Töm fältet',
        laster: 'Laddar',
        tildeltMeg: 'Tilldelat mig',
        visTildelt:
            'Visar scheman som är tilldelade dig. Sök och andra filter är avstängda.',
        sokUtenFiltre:
            'Söker i alla scheman. Andra filter är avstängda vid sökning.',
        velgFilter: 'Sök, eller välj minst ett filter för att visa scheman.',
    },
    status: {
        all: 'Alla statusar',
        select: 'Välj status',
        filter: 'Filtrera',
        selectedCount: '{{antall}} valda',
    },
    keyfigures: {
        title: 'Nyckeltal',
        areaTitle: 'Område',
        economyTitle: 'Ekonomisk',
        noContextSelected:
            'Du måste leta upp en byggnadsavdelning innan du kan se detta',
    },
    forvaltningsplan: {
        title: 'Förvaltningsplan',
        noContextSelected:
            'Du måste leta upp en byggnadsavdelning innan du kan se detta',
        edit: 'Redigera',
        read: 'Läs',
    },
    users: {
        title: 'Användaröversikt',
        searchField: 'Sök efter användare',
        fullname: 'Namn',
        name: 'Förnamn',
        surname: 'Efternamn',
        email: 'E-post',
        roles: 'Roller',
        region: 'Region',
        noUsers: 'Inga användare hittades.',
        editUser: {
            title: 'Hantera användare',
            titleWithName: 'Hantera användare: {{name}}',
            backButton: 'Tillbaka till användaröversikten',
            assignRoles: 'Tilldela roller',
            rolesDescription: 'Ange vilka roller användaren har',
            assignRegion: 'Tilldela region',
            regionDescription: 'Ange vilken region användaren tillhör',
            regionRequired: 'Region krävs',
        },
        showUserInfo: {
            title: 'Visa användarinformation',
            secondaryTitle: 'Användarinformation för {{name}}',
            backButton: 'Tillbaka till användaröversikten',
            labelRoles: 'Roller',
            rolesDescription: 'Användaren har följande roller',
            labelRegion: 'Region',
            regionDescription: 'Användaren tillhör följande region',
            prosjektkontrollerDescription:
                'Användaren ansvarar för följande byggavdelningar och företag som projektcontroller',
            labelBygg: 'Byggavdelningar',
            labelFirma: 'Företag',
        },
        action: {
            label: 'Handling',
            byggProsjektkontroller: 'Redigera ansvar för projektcontroller',
        },
        bpkModal: {
            title: 'Redigera byggavdelningar och företag för projektcontroller',
            description:
                'Ange byggavdelningar och företag som användaren ansvarar för som projektkontrollant',
            assigned: 'tilldelade',
            labelBygg: 'Välj byggnadsavdelning',
            labelFirma: 'Välj företag',
            save: 'Spara',
            assignedByggWarning:
                'Följande byggnader kommer att överföras till {{name}}',
            assignedFirmaWarning:
                'Följande företag kommer att överföras till {{name}}',
            saveCompletion:
                'Är du säker på att du vill överföra {{values}} till {{name}}?',
        },
        save: 'Spara',
        regionSelector: {
            Danmark: 'Danmark',
            Trondheim: 'Trondheim',
            Oslo: 'Oslo',
            Sverige: 'Sverige',
            Alle: 'Alla',
            Europa: 'Europa',
        },
        rolesSelector: {
            Teamleder: 'Teamledare',
            Drift: 'Drift',
            Forvalter: 'Förvaltare',
            Okonomi: 'Ekonomi',
            OkonomiQA: 'Ekonomi QA',
            Prosjektkontroller: 'Projektkontrollant',
            Prosjekteier: 'Projektbeställare',
            Prosjektleder: 'Projektägar',
            Prosjektdirektor: 'Projektchef',
            Forvaltningsdirektor: 'Förvaltningschef',
            Utviklingsdirektor: 'Utvecklingschef',
            Administrerendedirektor: 'Verkställande direktör',
            Okonomisjef: 'Redovisningschef',
            Teknisksjef: 'Teknisk chef',
            'user-admin': 'Användaradministratör',

            Avdelingsleder: 'Avdelningschef',
            Ledergruppedirektor: 'Ledningsgruppsdirektör',
            Risikovurderer: 'Risikovurderer',
            Leverandoroppretter: 'Leverandøroppretter',
            FagansvarligAapenhetsloven: 'Ämnesansvarig för Åpenhetsloven',
            Eiendomssjef: 'Fastighetschef',
            Regiondirektor: 'Regiondirektör',
        },
    },
    formGenerator: {
        approve: 'Godkänn',
        disapprove: 'Avvisa',
        submit: 'Slutför uppgiften',
        fieldRequired: 'Det här fältet är obligatoriskt',
        maxLengthExceeded: 'Texten får inte vara längre än {{max}} tecken',
        characterCount: '{{length}} / {{max}} tecken',
        assign: {
            title: 'Behöver du hjälp med att fylla i schemat?',
            description:
                'Tilldela uppgiften "{{oppgave}}" till en kollega med rätt roll ({{rolle}}) för att få hjälp med att fylla i formuläret.',
            assignTo: 'Tilldela till',
        },
        confirmDialog: {
            confirmDisapproval: 'Är du säker på att du vill avvisa formuläret?',
            confirm: 'Ja, avvisa',
        },
        roles: {
            Teamleder: 'Teamledare',
            Drift: 'Drift',
            Forvalter: 'Förvaltare',

            Bestiller: 'Beställare',
            Avdelingsleder: 'Avdelningschef',
            Ledergruppedirektor: 'Ledningsgruppsdirektör',
            Risikovurderer: 'Risikovurderer',
            Leverandoroppretter: 'Leverandøroppretter',

            Prosjekteier: 'Projektbeställare',
            Prosjektleder: 'Projektägare',
            Teknisksjef: 'Teknisk chef',
            Eiendomssjef: 'Fastighetschef',
            Prosjektdirektor: 'Projektledare',
            Forvaltningsdirektor: 'Förvaltningsdirektör',
            Utviklingsdirektor: 'Utvecklingsdirektör',
            Regiondirektor: 'Regiondirektör',
            Administrerendedirektor: 'Verkställande direktör',

            Okonomi: 'Projektkontrollant',
            Prosjektkontroller: 'Projektkontrollant',
            OkonomiQA: 'Ekonomi QA',
            Okonomisjef: 'Redovisningschef',

            'user-admin': 'Användaradministratör',
        },
        unsupportedFieldType: {
            title: 'Fälttyp stöds inte',
            message:
                'Fältet du försöker visa stöds inte i detta formulär. Kontrollera fälttypen eller kontakta support.',
            reloadButton: 'Ladda om formuläret',
        },
    },
    leverandor: {
        oppslag: {
            sokLabel: 'Sök (leverantörsnummer, org.nummer eller org.namn)',
        },
        title: 'Leverantörshantering',
        heading: 'Leverantörsschema',
        placeholder: 'Leverantörslista kommer här',
        abort: 'Avbryt',
        review: 'Granska',
        opprettetAv: 'Skapad av',
        completedBy: 'Utførs av: {{name}}\n{{date}}',
        completedDate: 'Utført: {{date}}',
        ansvarlig: 'Ansvarig: {{name}}',
        menuItems: {
            leverandor: 'Leverantörslista',
            root: 'Leverantör',
            skjema: 'Schema',
            leverandorReport: 'Leverantörrapport',
        },
        noContextSelected:
            'Du måste slå upp en leverantör innan du kan se detta',
        notFound:
            'Leverantören du försöker öppna finns inte. Gå tillbaka till översikten och välj en leverantör från listan.',
        backButton: 'Tillbaka till leverantörsöversikten',
        header: {
            documentation: 'Dokumentation',
        },
        cantFindProjectSchema:
            'Ett fel inträffade. Det gick inte att hitta leverantörsschema',
        activityAssignedToOtherUser:
            "Uppgiften är tilldelad '{{assigned}}', du kan därför inte ändra/slutföra uppgiften.",
        assignActivityToMe: 'Tilldela uppgiften till mig',
        insufficientUserRole:
            "Uppgiften kräver rollen '{{role}}', du är inte tilldelad denna roll.",
        adminInformation:
            "Uppgiften kräver rollen '{{role}}' och är tilldelad '{{assigned}}'. Du har administratörsroll och kan ändra/slutföra uppgiften.",
        completedActivity: 'Uppgiften har redan slutförts.',
        rejectedActivity: 'Formuläret har avvisats.',
        skipActivity:
            'Denna uppgift är inte relevant för flödet och kommer att hoppas över',
        deviationSystemLink: 'Länk till avvikelsesystem',
        processDefinition: {
            breadcrumb: 'Flödesdiagram',
            back: 'Tillbaka till dokumentation',
            title: 'Visuell representation av processdefintions flödesdiagram: {{processDefinitionId}}',
            iconTitle:
                'Se mer detaljerad representation av processdefinitions flödesdiagram',
            documentationTitle:
                'Dokumentation av processdefinitions flödesdiagram',
            selector: 'Välj processdefinition',
            helperText: 'Välj processdefinition för att filtrera leverantörer',
            zoomIn: 'Zooma in',
            zoomOut: 'Zooma ut',
            resetZoom: 'Återställ zoom',
            read: 'Öppna extern länk till Confluence sida för processdefiniton(er)',
        },
        table: {
            emptyTableMessage: 'Inga leverantörer hittades',
            orgnummer: 'ORG NUMMER',
            superOfficeContactId: 'Leverantör SO ID',
            d365Leverandornummer: 'Leverantörsnummer',
            superOfficeDocumentId: 'SuperOffice Dokument ID',
            namn: 'Namn',
            type: 'Typ',
            bestiller: 'Beställare',
            okonomi: 'Ekonomi',
            ansvarlig: 'Tilldelad till',
            opprettetAv: 'Skapad av',
            startDato: 'Startdatum',
            fullfortDato: 'Slutförd datum',
            action: 'Tiltak',
            status: 'Status',
            aktivitet: 'Uppgift',
            klassifisering: 'Klassificering',
            feltOppdateringFeilet: 'Kunde inte uppdatera fältet {{fieldName}}',
            ugyldigJSONBransje:
                'Fältet för bransch innehåller ogiltiga data och kan inte läsas.',
            ugyldigJSONKlassifisering:
                'Fältet för klassificering innehåller ogiltiga data och kan inte läsas.',
            actionMenuItems: {
                currentHeader: 'Tiltak för schema',
                visLeverandorSkjema: 'Visa schema',
                dokumentasjon: 'Visa dokumentation',
                lastNedDokument: 'Ladda ned dokument',
                forhaandsvisDokument: 'Förhandsgranska dokument',
                tildel: 'Tilldela ny ansvarig',
                sendReminder: 'Skicka påminnelse till ansvarig',
                sendKommentar: 'Skicka kommentar till rollinnehavare',
            },
            tildelAnsvarlig: {
                title: 'Tilldela ny ansvarig',
                ansvarlig: 'Ansvarig',
                tildel: 'Tilldela',
                avbryt: 'Avbryt',
            },
            roller: {
                Bestiller: 'Beställare',
                Avdelingsleder: 'Avdelningschef',
                Ledergruppedirektor: 'Ledningsgruppsdirektör',
                Risikovurderer: 'Riskbedömare',
                Leverandoroppretter: 'Leverantörsskapare',
                FagansvarligAapenhetsloven: 'Ämnesansvarig för Åpenhetsloven',
                Okonomi: 'Ekonomi',

                Prosjekteier: 'Projektbeställare',
                Prosjektleder: 'Projektägare',
                Forvaltningsdirektor: 'Förvaltningsdirektör',
                Utviklingsdirektor: 'Utvecklingsdirektör',
                Administrerendedirektor: 'Verkställande direktör',
                Prosjektdirektor: 'Projektledare',
                Okonomisjef: 'Redovisningschef',
                Prosjektkontroller: 'Projektkontrollant',
                Teknisksjef: 'Teknisk chef',
                Eiendomssjef: 'Fastighetschef',
                Regiondirektor: 'Regiondirektör',

                Ukjent: 'Ingen roller',
            },
            registreringStatus: {
                UnderVurdering: 'Under vurdering',
                Avvist: 'Avvisad',
                Fullfort: 'Färdig',
            },
        },
        statuses: {
            UnderVurdering: 'Under vurdering',
            Fullfort: 'Färdig',
            Avvist: 'Avvisad',
        },
        displayStatuses: {
            underGodkjenning: 'Under Godkännande',
            godkjent: 'Godkänd',
            ikkeGodkjent: 'Inte Godkänd',
        },
        successfulRegistration: 'Leverantören har registrerats.',
        successfulOperation: 'Tiltaket slutfördes framgångsrikt.',
        notAssignedToUser:
            'Du är inte tilldelad denna uppgift och kan därför inte slutföra den.',
        notAllowedToPerformAction:
            'Du har inte behörighet att utföra denna tiltak.',
        deleteLeverandor: {
            title: 'Ta bort schema',
            confirmationText: 'Är du säker på att du vill ta bort schema?',
        },
        sendKommentar: {
            title: 'Skicka kommentar till rollinnehavare',
            selectRole: 'Välj roll',
            commentLabel: 'Kommentar',
            send: 'Skicka',
        },
        opprettLeverandor: {
            title: 'Skapa leverantörsschema',
        },
        createLeverandor: {
            title: 'Skapa leverantörsschema',
            button: 'Skapa leverantörsschema',
            navigateToSchema: 'Gå till schema',
            successfulOperation: 'Leverantör skapad framgångsrikt.',
            existingProcessFound:
                'En process för denna leverantör finns redan.',
            validation: {
                regionRequired: 'Region är obligatorisk',
                orgnummerRequired: 'Organisationsnummer är obligatoriskt',
                orgnummerDigits:
                    'Organisationsnummer måste endast innehålla siffror',
                typeRequired: 'Type är obligatorisk',
                countryRequired: 'Land är obligatorisk',
            },
            region: {
                label: 'Välj region för leverantören',
                oslo: 'Oslo',
                trondheim: 'Trondheim',
                sverige: 'Sverige',
                danmark: 'Danmark',
                europa: 'Europa',
            },
            country: {
                Norway: 'Norge',
                Sweden: 'Sverige',
                Denmark: 'Danmark',
                UnitedKingdom: 'Storbritannien',
                Other: 'Annat',
            },
            orgnummer: {
                label: 'Velg organisasjon',
                placeholder: 'Ange namn eller org.nummer',
                placeholderSweden: 'Ange org.nummer',
            },
            manualEntry: {
                nameLabel: 'Företagsnamn',
                namePlaceholder: 'Ange företagsnamn',
                orgNumberLabel: 'Organisationsnummer',
                orgNumberPlaceholder: 'Ange org.nummer',
                countryLabel: 'Land',
                countryPlaceholder: 'Ange land',
            },
            superOffice: {
                label: 'SuperOffice-kontakt',
                loading: 'Söker i SuperOffice...',
                notFoundAlert: 'Ingen befintlig företag hittad',
                notFoundAlertDescription:
                    'En ny företag kommer att skapas i SuperOffice',
                foundAlert: 'Befintlig företag hittad',
                foundAlertDescription:
                    'Befintlig företag kommer att användas: {{navn}}',
                error: 'Fel vid sökning i SuperOffice',
                selectOption: 'Välj företag',
                companyId: 'SuperOffice företags-ID',
                klassifisering: 'Klassificering',
            },
            duplicateSuperofficeContactsFound:
                '{{count}} befintliga SuperOffice-företag hittade för denna organisation. Vänligen välj vilket du vill använda:',
            type: {
                label: 'Type',
                fastleverandor: 'Leverantör',
                engangsleverandor: 'Engångsleverantör',
                engangsleverandorInfo:
                    'En engångsleverantör kan bara användas en gång för belopp mindre än 15 000 NOK/15 000 SEK/10 000 DKK (exkl. moms)',
            },
        },
        TildelKommentarer: {
            field: {
                label: 'Kommentar vid tilldelning',
                placeholder:
                    'Skriv in en kommentar för den person du tilldelar',
                error: {
                    commentTooLong:
                        'Det gick inte att spara kommentaren i formuläret. Kommentaren är för lång och överskrider tillåten längd.',
                },
            },
            list: {
                title: 'Kommentarer vid tilldelning',
                empty: 'Inga kommentarer',
            },
        },
        rolleKommentarer: {
            list: {
                title: 'Kommentarer',
                empty: 'Inga kommentarer',
                reply: 'Svara',
                replyTo: 'Svara till {{role}}',
                cannotDelete: 'Kan inte ta bort kommentarer med svar',
                fra: 'Från',
                til: 'Till',
                svarTil: 'Svar till',
            },
            field: {
                error: {
                    commentTooLong:
                        'Kommentaren är för lång och överskrider tillåten längd.',
                },
            },
        },
        risikovurdering: {
            openButton: 'Öppna Riskbedömning',
            updateButton: 'Fyll fält med värden från Riskbedömning',
            button: 'Riskbedömning',
            notFoundInDNB: 'Kan inte hitta leverantör i DNB för riskbedömning',
            fieldsUpdated: 'Fälten har uppdaterats',
            updateError: 'Fel vid uppdatering av fält',
            fetchError: 'Fel vid hämtning av riskbedömningsdata',
        },
        inherentRisk: {
            breadcrumb: 'Inneboende risk',
            title: 'Branscher - Inneboende risk',
            subtitle: 'Bedömning av inneboende risk för olika branscher',
            selectRiskLabel: 'Välj risknivå',
            low: 'Låg risk',
            medium: 'Medium risk',
            high: 'Hög risk',
            notSet: 'Inte angivet',
            searchPlaceholder: 'Sök efter bransch',
            success: 'Riskbedömning uppdaterad',
            error: 'Fel vid uppdatering av riskbedömning',
            table: {
                bransje: 'Bransch',
                beskrivelse: 'Beskrivning',
                risk: 'Risknivå',
            },
        },
        schemaRisk: {
            low: 'Låg',
            medium: 'Medium',
            high: 'Hög',
            schemaWarning:
                'Leverantörsbedömningen visar hög risk i förhållande till den norska Åpenhetsloven. Lucas van Laack (hållbarhetschef) kommer att inkluderas i processen för en due diligence-bedömning och vidare uppföljning. Kom ihåg att beställaren alltid är risktagaren.',
            schemaSafe:
                'Bedömningen visar låg eller medium risk i förhållande till den norska Åpenhetsloven. Ingen tiltak krävs.',
        },
        processId: 'Process-ID',
        startDate: 'Startdatum',
        startedBy: 'Startad av',
        region: 'Region',
    },

    project: {
        title: 'Projekt- och tiltaksscheman',
        header: {
            documentation: 'Dokumentation',
            fullmakt: 'Fullmaktsgränser',
        },
        noContextSelected:
            'Du måste leta upp en byggnadsavdelning innan du kan se detta',
        notFound:
            'Projektet du försöker öppna finns inte. Gå tillbaka till översikten och välj ett projekt från listan.',
        backButton: 'Tillbaka till projektöversikten',
        backButtonHistorikk: 'Tillbaka till projektsammanfattningen',
        menuItems: {
            root: 'Projekt / tiltak',
            schema: 'Schema',
            report: 'Rapport',
        },
        abort: 'Avbryt',
        review: 'Granska',
        opprettetAv: 'Skapad av',
        completedBy: 'Utførs av: {{name}}\n{{date}}',
        completedDate: 'Utført: {{date}}',
        tildelt: 'Tilldelad:',
        ansvarlig: 'Ansvarig: {{name}}',
        formFields: {
            aarsbudsjett: 'Årsbudsjett',
            mainTitle: 'Projekt- och tiltaksschema',
            generelleOpplysningerTitle: 'Allmän information',
            eiendomsnavn: 'Fastighetsnamn',
            delAvEiendom: 'Del av fastighet',
            utleieareal: 'Uthyrningsyta',
            prosjektareal: 'Projektyta',
            informationOmProsjekt: 'Projektinformation',
            oppstartsdato: 'Startdatum',
            mvapliktig: 'Är hyresgästen momspliktig (0-100%)?',
            opprettetSuperOffice: 'Är projektet skapat i SuperOffice?',
            lonnsomhetsberegning:
                'Lönsamhetsberäkning godkänd av avdelningschef och sparad i SuperOffice?',
            lonnsomhetsberegningLink:
                'Länk till lönsamhetsberäkning i SuperOffice',
            signertLeietaker: 'Mottaget hyreskontrakt signerat av hyresgästen?',
            signertLeietakerLink: 'Länk till signerat hyreskontrakt',
            signertKLP: 'Hyreskontrakt signerat av KLP?',
            prosjektBudsjett: 'Projektbudget',
            prosjektokonomiTitle: 'Projektekononomi',
            budsjettert: 'Budgeterat?',
            pbv1: 'PB V1',
            andelKostnadsforing: 'Andel kostnadsföring',
            leietakerTitle: 'Hyresgäst',
            firmanavn: 'Företagsnamn',
            firmanavnSøkeresultat: 'Företagsnamn (sökresultat)',
            organisasjonsnummer: 'Organisationsnummer',
            sendVidereTilTitle: 'Fortsätt skicka till',
            prosjektleder: 'Projektledare',
            utviklingsdirektor: 'Utvecklingsdirektör',
            kommentarerTitle: 'Kommentarer',
            kommentarForvaltningsdirektor: 'Kommentar - förvaltningsdirektör',
            kommentarForvaltningsdirektorGodkjent:
                'Projektet är godkänt av förvaltningsdirektören med följande kommentar',
            kommentarUtviklingsdirektor: 'Kommentar - utvecklingsdirektör',
            kommentarUtviklingsdirektorGodkjent:
                'Projektet är godkänt av utvecklingsdirektören med följande kommentar',
            kommentarAdministrerendedirektor:
                'Kommentar - verkställande direktör',
            kommentarAdministrerendedirektorGodkjent:
                'Projektet är godkänt av verkställande direktören med följande kommentar',
            kommentarProsjektdirektor: 'Kommentar - projektledare',
            kommentarProsjektdirektorGodkjent:
                'Projektet är godkänt av projektledaren med följande kommentar',
            prosjektcontroller: 'Projektkontrollant',
            andreSystemerTtle: 'Andra system',
            prosjektNummerAxapta:
                'Skapat i Axapta och följande är rätt projektnummer',

            firmaDetaljer: {
                registrertIMvaregisteret: 'Registrerad i momsregistret',
                registrertIForetaksregisteret:
                    'Registrerad i företagsregistret',
                registreringsdatoEnhetsregisteret:
                    'Registrerad i enhetsregistret',
                registreringsdatoAntallAnsatteNAVAaregisteret:
                    'Registrerad i NAV Aa-registeret',
                konkurs: 'Konkurs',
                underAvvikling: 'Under avveckling',
                underTvangsavviklingEllerTvangsopplosning:
                    'Under tvångsavveckling eller tvångsupplösning',
            },
            manuellRegistrering: 'Manuell registrering',
            firmanavnManuell: 'Företagsnamn',
            manueltRegistrertInfo:
                'Manuellt registrerat — ingen data från Brønnøysundregisteret',
            radioGroup: {
                yes: 'Ja',
                no: 'Nej',
            },
            calculatedSelectorEditable: {
                editedLabel:
                    'Det automatiskt beräknade värdet {{name}} har skrivits över. Du kan återställa det genom att klicka på krysset i fältet ovan.',
            },
        },

        steps: {
            step1: {
                title: 'Definiera projekt',
                description:
                    'Här definierar du projektet och fyller i allmän information.',
            },
            step2: {
                title: 'Kontrollera och korrigera',
                description:
                    'Här kan du kontrollera och korrigera informationen som har fyllts i.',
            },
            step3: {
                title: 'Godkännande av förvaltningsdirektör',
                description:
                    'Här godkänns projektet av förvaltningsdirektören.',
            },
            step4: {
                title: 'Godkännande av utvecklingsdirektör',
                description: 'Här godkänns projektet av utvecklingsdirektören.',
            },
            step5: {
                title: 'Godkännande av verkställande direktör',
                description:
                    'Här godkänns projektet av verkställande direktören.',
            },
            step6: {
                title: 'Projektkontrollant',
                description:
                    'Här fyller projektkontrollanten i information om projektet.',
            },
        },
        opprettProsjekt: {
            title: 'Skapa projekt / tiltakschema',
            type: 'Typ',
            step: 'Steg',
            selectStep: 'Välj steg',
            noStepSelected: '--- Inget värde ---',
            superOfficeProsjekt: 'Projekt i SuperOffice',
            superOfficeProsjektPlaceholder: 'Sök efter SuperOffice-prosjekt',
            opprettProsjektKnapp: 'Skapa projekt / tiltakschema',
            goToSuperOffice: 'Gå till SuperOffice',
            prosjektskjematype: {
                label: 'Välj projektschematyp',
                hovedprosjekt: 'Huvudprojekt',
                underprosjekt: 'Delprojekt',
            },
            // Om en analys av kostnader och lönsamhet ska göras för projektet, välj "Lönsamhetsbedömning". \n\n
            LTT: 'Om det finns behov av ett förprojekt, antingen för att förbereda ett erbjudande till en hyresgäst, eller en begäran om ett erbjudande till entreprenörer, välj "Förprojekt". \n\nOm hyreskontraktet är tecknat och projektledare har valt entreprenör kan du gå direkt till "Genomförande".',
            KOM: 'Om du behöver förbereda några enkla skisser eller göra annan mindre research inför ett förprojekt, och som har en total kostnad på mindre än 50 000 NOK, välj "Skiss". \n\nOm du behöver en projektledare, eller om den totala kostnaden för skisser och undersökningar överstiger 50 000 NOK, välj "Förprojekt".',
            TEK: 'Med förprojekt?',
            prosjekterNotFound:
                'Inga projekt hittades, gå till SuperOffice för att skapa projekt',
            radioGroup: {
                Lonnsomhetsberegning: {
                    title: 'Lönsamhetsbedömning',
                },
                Skisse: {
                    title: 'Skiss',
                    KOM: 'Det finns behov av att förbereda några enkla skisser eller göra andra mindre undersökningar inför ett förprojekt, med en total kostnad på mindre än 50.000,-',
                },
                Forprosjekt: {
                    title: 'Förprojekt',
                    LTT: 'Det finns behov av förprojekt, antingen för att förbereda erbjudande till hyresgäst eller offertförfrågan till entreprenörer',
                    KOM: 'Det finns behov av en projektledare, eller den totala kostnaden för skisser och undersökningar överstiger 50.000,-',
                    TEK: 'Det finns behov av förprojekt, antingen för att förbereda erbjudande till hyresgäst eller offertförfrågan till entreprenörer',
                },
                Gjennomforing: {
                    title: 'Genomförande',
                    LTT: 'Kontraktet är tecknat och projektledare har valt entreprenör',
                    TEK: 'Kontraktet är tecknat och projektledare har valt entreprenör',
                },
                Tilbud: {
                    title: 'Tilbud',
                },
            },
            disabledButton:
                'För att skapa ett projektschema måste du välja typ och underkategori',
            occupiedProject: ' --- PROJEKTET ÄR UPPTAGET ---',
            types: {
                LTT: 'Hyresgästanpassning (LTT)',
                KOM: 'Kommersiell (KOM)',
                TEK: 'Teknisk (TEK)',
                TILTAK: 'Tiltak',
            },
        },
        types: {
            LTT: 'Hyresgästanpassning',
            LTT_Abbreviation: 'LTT',
            KOM: 'Kommersiell',
            KOM_Abbreviation: 'KOM',
            TEK: 'Teknisk',
            TEK_Abbreviation: 'TEK',
            TILTAK: 'Tiltak',
            Unknown: 'Okänd typ',
        },
        subTypes: {
            Opprettelse: 'Skapande',
            Skisse: 'Sketch',
            Igangsettelse: 'Driftsättning',
            Bestilling: 'Beställning',
            Endring: 'Ändring',
            Avslutning: 'Avslutning',
        },
        stepTypes: {
            Ny: 'Ny',
            Avvist: 'Avvist',
            Fullfort: 'Fullført',
        },
        errors: {
            invalidLink: 'Länken är inte giltig',
            invalidProjectNumber:
                'Projektnummer måste vara i formen "<Företagsnummer>.<D365 serienummer (4 siffror)>" t.ex. "N202.0435"',
            savePrompt: 'Ett fel uppstod när schemainnehållet skulle sparas.',
            companyNotSelected:
                'Sök efter företagets namn eller nummer och välj ett från listan',
            invalidOrgnumber: 'Ogiltigt organisationsnummer',
            invalidTotalVurderingsskjema:
                'Ogiltig sum - värdet måste vara större än 0',
        },
    },
    prosjekt: {
        cantFindProjectSchema:
            'Ett fel har inträffat. Kan inte hitta projektschema',
        oppslag: {
            sokLabel: 'Sök (projektnummer, projektnamn eller fastighet)',
        },
        activityAssignedToOtherUser:
            "Uppgiften är tilldelad '{{assigned}}', du kan därför inte ändra/utföra uppgiften.",
        assignActivityToMe: 'Tilldela mig uppgiften',
        insufficientUserRole:
            "Uppgiften kräver rollen '{{role}}', du är inte tilldelad denna roll.",
        notCandidateGroupOwner:
            "För att slutföra denna uppgiften måste du vara tilldelad rollen '{{owner}}'. Dina roller är '{{userRoles}}'",
        adminInformation:
            "Uppgiften kräver rollen '{{role}}' och är tilldelad '{{assigned}}'. Du har admin-roll och kan ändra/utföra uppgiften.",
        completedActivity: 'Uppgiften är redan utförd.',
        rejectedActivity: 'Formuläret har avvisats.',
        skipActivity:
            'Denna uppgift är inte relevant för flödet och bör hoppas över',
        processDefinition: {
            breadcrumb: 'Flödesschema',
            back: 'Tillbaka till dokumentation',
            title: 'Visuell representation av flödesschema för processdefinition: {{processDefinitionId}}',
            iconTitle:
                'Se mer detaljerad representation av flödesschema för processdefinitioner',
            documentationTitle:
                'Dokumentation av flödesschema för processdefinitioner',
            selector: 'Välj processdefinition',
            helperText: 'Välj processdefinition för att filtrera projekt',
            zoomIn: 'Zooma in',
            zoomOut: 'Zooma ut',
            resetZoom: 'Återställ zoom',
            read: 'Öppna extern länk till Confluence-sida för processdefinition(er)',
        },
        definitions: {
            prosjekt_ltt_godkjenning: 'Hyresgästanpassning - Förprojekt',
            prosjekt_ltt_bestilling: 'Hyresgästanpassning - Genomförande',
            prosjekt_ltt_endring: 'Hyresgästanpassning - Ändring',
            prosjekt_ltt_avslutning: 'Hyresgästanpassning - Avslutning',
            prosjekt_kom_skisse: 'KOM - Skiss',
            prosjekt_kom_opprettelse: 'KOM - Förprojekt',
            prosjekt_kom_bestilling: 'KOM - Genomförande',
            prosjekt_kom_endring: 'KOM - Ändring',
            prosjekt_kom_avslutning: 'KOM - Avslutning',
            prosjekt_tek_igangsettelse: 'TEK - Förprojekt',
            prosjekt_tek_bestilling: 'TEK - Genomförande',
            prosjekt_tek_endring: 'TEK - Ändring',
            prosjekt_tek_avslutning: 'TEK - Avslutning',
            tiltak_gjennomforing: 'Tiltak - Genomförande',
            tiltak_avslutning: 'Tiltak - Avslutning',
        },
        fullmakt: {
            breadcrumb: 'Fullmaktsgränser',
            title: 'Fullmaktsgränser för projektschema',
            subtitle:
                'Översikt över fullmakter och godkännande myndigheter. Alla belopp är exkl. moms.',
            groupBy: 'Gruppera efter:',
            noGroup: 'Visa alla',
            table: {
                allTitle: 'Alla fullmakter',
                region: 'Region',
                avdeling: 'Avdelning',
                stilling: 'Befattning',
                innenfor: 'Budgeterat',
                utover: 'Inte budgeterat',
                endring: 'Ändring i budget',
            },
        },
        statuses: {
            TilbudUnderGodkjenning: 'Tilbud under godkännande',
            Tilbud: 'Tilbud',
            UnderSkissering: 'Under skissering',
            Skissert: 'Skisserad',
            LonnsomhetsberegningUnderGodkjenning:
                'Lönsamhetsbedömning under godkännande',
            Lonnsomhetsberegning: 'Lönsamhetsbedömning',
            ForprosjektUnderGodkjenning: 'Förprojekt under godkännande',
            Forprosjekt: 'Förprojekt',
            GjennomforingUnderGodkjenning: 'Genomförande under godkännande',
            Gjennomforing: 'Genomförande',
            TilEndring: 'Ändring budget under godkännande',
            Endret: 'Genomförande ändrad budget',
            TilAvslutning: 'Avslutning under godkännande',
            Avsluttet: 'Avslutad',
            Avvist: 'Avvisad',
        },
        table: {
            actionMenuItems: {
                stepHeader: 'Skapa schema för',
                currentHeader: "Tiltak för '{{stegNavn}}'",
                Igangsettelse: 'Start',
                Skisse: 'Skiss',
                Tilbud: 'Erbjudande',
                Forprosjekt: 'Förprojekt',
                Godkjenning: 'Godkännande',
                Gjennomforing: 'Genomförande',
                Endring: 'Ändring budget',
                Avslutning: 'Avslutning',
                detaljer: 'Visa detaljer',
                tildel: 'Tilldela ny ansvarig',
                tildelRolle: 'Tilldela ny: {{rolle}}',
                sammendrag: 'Visa sammanfattning',
                sendReminder: 'Skicka påminnelse till ansvarig',
                sendReminderName: 'Skicka påminnelse till {{name}}',
                dokumentasjon: 'Visa dokumentation',
            },
            tildelAnsvarlig: {
                title: 'Tilldela ny ansvarig',
                ansvarlig: 'Ansvarig',
                tildel: 'Tilldela',
                avbryt: 'Avbryt',
                Prosjekteier: 'Projektbeställare',
                Prosjektleder: 'Projektägare',
                Forvaltningsdirektor: 'Förvaltningsdirektör',
                Utviklingsdirektor: 'Utvecklingsdirektör',
                Administrerendedirektor: 'Verkställande direktör',
            },
            roller: {
                Prosjekteier: 'Projektbeställare',
                Prosjektleder: 'Projektägare',
                Forvaltningsdirektor: 'Förvaltningsdirektör',
                Utviklingsdirektor: 'Utvecklingsdirektör',
                Administrerendedirektor: 'Verkställande direktör',
                Prosjektdirektor: 'Projektledare',
                Okonomisjef: 'Redovisningschef',
                Prosjektkontroller: 'Projektkontrollant',
                Okonomi: 'Projektkontrollant',
                Teknisksjef: 'Teknisk chef',
                Eiendomssjef: 'Fastighetschef',
                Regiondirektor: 'Regiondirektör',
                Ukjent: 'Ingen roller',
            },
            subTypes: {
                Forprosjekt: 'Förprojekt',
                Gjennomforing: 'Genomförande',
                Endring: 'Ändring',
                Avslutning: 'Avslutning',
                Tilbud: 'Erbjudande',
            },
            registreringStatus: {
                Ny: 'Ny',
                Avvist: 'Avvisad',
                Fullfort: 'Fullförd',
            },
            tableTitle: 'Utförda uppgifter i steget',
            type: 'TYP',
            navn: 'NAMN',
            d365Prosjektnummer: 'NUMMER',
            eiendom: 'FASTIGHET',
            rolle: 'ROLL(ER)',
            email: 'E-POST',
            signeringsDato: 'SIGNERINGSDATUM',
            beskrivelse: 'BESKRIVNING',
            status: 'STATUS',
            opprettetAv: 'SKAPAD AV',
            endretAv: 'ÄNDRAD AV',
            ansvarlig: 'TILLDELAD TILL',
            startDato: 'STARTDATUM',
            sluttDato: 'SLUTDATUM',
            fullfortDato: 'FULLFÖRT DATUM',
            action: 'TILTAK',
            utforelseDato: 'UTFÖRANDEDATUM',
            oppgave: 'UPPGIFT',
            prosjekteier: 'PROJEKTBESTÄLLARE',
            prosjektleder: 'PROJEKTÄGARE',
            emptyTableMessage:
                'Vi hittar inga projekt baserat på de filter du har valt.',
            lastNedDokument: 'Ladda ner dokument',
            forhaandsvisDokument: 'Förhandsgranska dokument',
            visDetaljertProsjektregistrering:
                'Visa detaljerad översikt av det valda processsteget',
            visProsjektSkjema: 'Visa schema',
            visProsjektISuperoffice: 'Öppna projekt i SuperOffice',
            prosjektskjematype: 'PROJEKTSCHEMATATYP',
            aapneISuperOffice: 'Öppna projekt i SuperOffice',
        },
        filter: {
            prosjektskjematype: {
                label: 'Schematyp',
                all: 'Alla',
                hovedprosjekt: 'Huvudprojekt',
                underprosjekt: 'Delprojekt',
            },
        },
        summary: {
            title: 'Projektsammanfattning - {{prosjektNavn}}',
        },
        notification: 'Behandlar förfrågan. Vänta...',
        error: 'Ett fel uppstod. Försök igen senare.',
        deleteProject: {
            title: 'Ta bort schema',
            confirmationText: 'Är du säker på att du vill ta bort schema?',
        },
        successfulRegistration: 'Projektet har registrerats.',
        successfulOperation: 'Tiltaket utfördes framgångsrikt.',
        notAssignedToUser:
            'Du är inte tilldelad denna uppgift och kan därför inte utföra den.',
        notAllowedToPerformAction:
            'Du har inte behörighet att utföra denna tiltak.',
        newProcess: 'Nya projekt',
        ongoingProcessForvalter: 'Hos förvaltare',
        ongoingProcessFinance: 'Hos ekonomi',
        startRegistration: 'Starta registrering',
        declined: 'Avvisad',
        approved: 'Godkänd',
        forApproval: 'För godkännande',
        assignedToMe: 'Tilldelad mig',
        avvistKommentarTitle:
            "Uppgiften '{{avvistOppgave}}' har avvisats med följande kommentar:",
        stepper: {
            unathorisedStep: 'Du har inte behörighet till detta steg',
        },
        vurderingsskjema: {
            close: 'Stäng',
            open: 'Öppna utvärderingsschema',
            title: 'Utvärderingsschema',
            sum: 'Summa: ',
            oppsummeringAvSummer: 'Sammanfattning av summor',
            sumAlleKategorier: 'Alla kategorier: ',
            sumAktivering: 'Aktivering: ',
            sumKostnadsforing: 'Kostnadsföring: ',
            sumAndelAktivering: 'Andel aktivering: ',
            sumAndelKostnadsforing: 'Andel kostnadsföring: ',
            navn: 'Namn',
            kostkategoriId: 'KostkategoriId',
            kostnadsforing: 'Kostnadsföring',
            aktivering: 'Aktivering',
            total: 'Total',
            totalOversikt: 'Total baserat på schema',
            kommentar: 'Kommentar',
            inputMode: {
                toggleLabel: 'Registrera med totalsumma och procentfördelning',
                helperText:
                    'Ange totalsumma och procent per rad; aktivering och kostnadsföring beräknas automatiskt.',
                aktiveringPct: 'Aktivering %',
                kostnadsforingPct: 'Kostnadsföring %',
            },
            error: {
                paakrevdKommentar: 'Kommentar krävs',
                hasErrors: 'Formuläret har {{count}} fel',
                hasErrors_1: 'Formuläret har 1 fel',
            },
        },
        kostnadskalkyle: {
            title: {
                tab: 'Kalkyl',
                general: 'Kalkyl och lönsamhetsbedömning för projekt',
                kalkyle: 'Kalkyl för projekt: {{prosjektNavn}}',
                lonsomhetsberegning:
                    'Lönsamhetsbedömning för projekt: {{prosjektNavn}}',
                modalButton: 'Öppna kalkyl',
            },
            submit: 'Skicka in kalkyl',
            administrerKostnadstyper: 'Hantera kostnadstyper',
            disabledTab: 'Inaktiverad för denna projekttyp',
            leggTilKostnadstype: 'Lägg till kostnadstyp',
            addKostnadstype: {
                name: 'Namn',
                duplicateError: "Kostnadstypen '{{name}}' finns redan",
            },
            velgKostnadstype: 'Välj kostnadstyp',
            kostnadstypeWarning: 'Vald kostnadstyp är markerad som raderad',
            velgKostkategori: 'Välj kostnadskategori',
            lagrer: 'Sparar',
            lagre: 'Lägg till',
            prosjektArealM2: 'Projektarea (kvm)',
            risikotilleggSats: 'Sats för risktillägg (%)',
            prosjektlederSats: 'Sats för projektledartimmar (%)',
            tillegg: {
                title: 'Tillägg',
                risiko: 'Risk',
                prosjektleder: 'Projektledare',
                time: 'timme',
                timer: 'timmar',
            },
            leieobjektArealM2: 'Hyresobjekt inkl. andel gemensamhetsyta (kvm)',
            kontraktsleiePerM2: 'Kontrakthyra per m²',
            leieperiode: 'Hyresperiod (år)',
            aarligLeie: 'Årlig hyra',
            totalLeie: 'Total hyra',
            error: {
                kostnadstypeRequired: 'Kostnadstyp är obligatorisk',
                satsRequired: 'Sats är obligatorisk',
                satsRange: 'Sats måste vara mellan 0 och 100',
                enhetRequired: 'Enhet är obligatorisk',
                enhetPositive: 'Enhet måste vara större än 0',
                prisPerEnhetRequired: 'Pris per enhet är obligatorisk',
                prisPerEnhetPositive: 'Pris per enhet måste vara större än 0',
                andelKostnadsforingRequired:
                    'Andel kostnadsföring är obligatorisk',
            },
            table: {
                kostnadstype: 'Kostnadstyp',
                beskrivelse: 'Beskrivning',
                kostnad: 'Kostnad',
                enhet: 'Antal (st/m/m²)',
                prisPrEnhet: 'Pris per enhet',
                aktiveringsandel: 'Aktiveringsandel (%)',
                kostnadsforingAndel: 'Andel kostnadsföring (%)',
                sumAktivering: 'Summa aktivering',
                handlinger: 'Tiltak',
                addRow: 'Lägg till rad',
            },
            summary: {
                section_project: 'Nyckeltal om projektet',
                totalKostnad: 'Totalkostnad',
                kvadratMeterPris: 'Kvadratmeterpris',

                section_historical: 'Historiska nyckeltal för fastigheten',
                gjennomsnittligKostnadPerM2: 'Genomsnittlig kostnad per m²',

                section_financial: 'Nyckeltal för redovisning',
                andelAktiveres: 'Andel aktiveras',
                andelKostnadsfores: 'Andel kostnadsförs',
            },
        },
        lonnsomhet: {
            title: 'Lönsamhet',
            fields: {
                kontraktleieTotaltPerAar: 'Total kontraktshyra/år',
                grunnleiePerM2: 'Bas hyra per m²',
                oktLeiePerM2PerAar: 'Ökad hyra per m²/år',
                nyGrunnleiePerM2PerAar: 'Ny bas hyra per m²/år',
                inflasjon: 'Inflation (%)',
                avkastningskrav: 'Avkastningskrav (%)',
                realAvkastningskrav: 'Realt avkastningskrav (%)',
                oktInntektPerM2PerAar: 'Ökad inkomst per m²/år',
                oktInntektPerAar: 'Ökad inkomst/år',
                terminerPerAar: 'Terminer per år',
                kontraktstid: 'Kontraktstid (år)',
            },
            table: {
                navn: 'Namn',
                investeringskostnad: 'Investeringskostnad',
                avskrivningstid: 'Avskrivningstid',
                restverdi: 'Restvärde (%)',
                aarligOktLeiepris: 'Årlig ökad hyra',
                oktLeieprisPerM2: 'Ökad hyra per m²',
                leggTilDelprosjekt: 'Lägg till delprojekt',
                totalt: 'Totalt',
                nettoLeie: 'Nettohyra',
                inkluderMvaKompensasjon: 'Inkludera moms',
                noData: 'Det finns ingen data i kostnadskalkylen ännu. Fyll gärna i formuläret för att se lönsamhetsberäkningen.',
            },
        },
        kostnadstyper: {
            title: 'Kostnadstyper',
            showDeleted: 'Visa raderade kostnadstyper',
            table: {
                navn: 'Namn',
                kostkategori: 'Kostnadskategori',
                defaultCost: 'Standardkostnad',
                defaultKostnadsforingAndel: 'Standard andel kostnadsföring (%)',
                edit: 'Redigera kostnadstyp',
                save: 'Spara kostnadstyp',
                add: 'Lägg till kostnadstyp',
                delete: 'Ta bort kostnadstyp',
                deletePrompt:
                    'Är du säker på att du vill ta bort kostnadstypen?',
                deleteConfirm: 'Ta bort',
                cancel: 'Avbryt',
                restore: 'Återställ kostnadstyp',
                duplicateError:
                    'En kostnadstyp med samma namn och kostnadskategori finns redan',
            },
            error: {
                navnRequired: 'Namn krävs',
                kostKategoriRequired: 'Kostnadskategori krävs',
                duplicate:
                    'Kostnadstypen med namn {{name}} och kostnadskategori {{kostkategori}} finns redan',
            },
        },
        leverandor: {
            organizationSelect: 'Begärd företag',
            organizationPlaceholder: 'Organisationsnummer',
            price: 'Pris',
            priceRevised: 'Korrigerat pris',
            selected: 'Vald',
            klassifisering: 'Klassificering',
            add: 'Lägg till',
        },
        vedlegg: {
            add: 'Lägg till bilaga',
            delete: 'Radera bilaga',
            loading: 'Laddar upp bilaga',
        },
        budsjettnummer: {
            title: "Budget '{{number}}' i D365",
            period: 'Period: {{from}} - {{to}}',
            budget: 'ExMVA: {{exMva}}, MVA: {{mva}}, Totalt: {{total}}',
        },
        dokument: {
            add: 'Lägg till',
            loading: 'Laddar upp',
        },
        TildelKommentarer: {
            field: {
                label: 'Kommentar vid tilldelning',
                placeholder: 'Skriv en kommentar till personen du tilldelar',
                error: {
                    commentTooLong: {
                        sv: 'Kunde inte spara kommentaren i schemat. Kommentaren är för lång och överskrider den tillåtna längden.',
                    },
                },
            },
            list: {
                title: 'Kommentarer vid tilldelning',
                empty: 'Inga kommentarer',
            },
        },
    },
    frontPage: {
        buildings: 'Egendom',
        buildingsLink: 'Mina egendommer',
        contract: 'Kontrakter',
        frontpage: 'Framsidan',
        invoice: 'Faktura',
        invoiceLink: 'Alla fakturor',
        messages: 'Anslagstavla',
        messagesLink: 'Alla meddelanden',
        mytasksLink: 'Fallöversikt',
        welcome: {
            forvalter: 'Välkommen till dashbord för fastigheter',
            yourAdminDashboard:
                'Välkommen till dashbord för fastigheter, {{name}}',
        },
        adjustFrontpage: {
            title: 'Anpassa framsidan',
            alert: 'Nu visas standardframsidan för din roll. Du kan enkelt anpassa framsidan efter dina behov nedan',
            select: 'Välj vad som visas på framsidan',
            frontpageCardsSelector: {
                utestaaendeFordringer: 'Utestående fordringar',
                arealmessigUtleiegrad: 'Arealmessig utlejegrad',
                kontrakter: 'Kontrakt',
                prosjekter: 'Projekt/tiltak',
                saker: 'Ärenden',
                leverandor: 'Leverantör',
            },
        },
        survey: {
            title: 'Hej{{name}}!',
            description1:
                'Har du 5 minuter på dig att ge lite feedback om hur vi kan förbättra dashbord för fastigheter?',
            description2:
                'Vi på IT-avdelningen uppskattar verkligen din hjälp!',
            linkText: 'Gå till undersökningen',
        },
        expiredContracts: {
            actionButtonText: 'Se lediga lokaler',
            area: 'Areal',
            areaRatio: 'Arealmässigt beläggningsgrad',
            available: 'Fri',
            contracts: 'Kontrakter',
            econRatio: 'Ekonomisk uthyrningsgrad',
            income: 'Hyresintäkt',
            marketValue: 'Marknadsvärde',
            nokperyear: 'NOK/År',
            rented: 'Hyrde ut',
            rentedExpiring: 'Utgår',
            title: 'Tillgängliga lokaler',
            yourAvailableAreasDate: 'Mina tillgängliga lokaler per ',
            yourRentedAreasDate: 'Mina utleide areal per ',
        },
        expiringContracts: {
            actionButtonText: 'Se kontrakt som löper ut',
            title: 'Kontraktets utgång',
            yourExpiringContracts: 'Mina kontrakt som löper ut',
            yourRentalRateDate: 'Min uthyrningsgrad pr ',
        },
        utestaaendeFordringer: {
            allReceivables: 'Se alla fordringar',
            actionButtonText: 'Se mina fordringar',
            emptyResult:
                'Det finns inga utestående fordringar du behöver följa upp.',
            title: 'Utestående fordringar',
            subtitle: 'Kunder med utestående fordringar',
        },
        contractManagement: {
            actionButtonText: 'Kontraktshantering',
            contractsToRegistration: 'Väntar på registrering i D365',
            negotiations: 'Negotiations',
            signableContracts: 'Kontrakt för undertecknande',
            subtitle: 'Kontraktshantering',
            title: 'Kontrakter',
            newProsessLink: 'Startas ny proces',
            infoText:
                'Denna kontraktsöversikt filtreras inte på den valda byggnaden.',
        },
        project: {
            actionButtonText: 'Projektschema',
            subtitle: 'Projektledning',
            title: 'Projekt',
            newProjectLink: 'Skapa nytt projekt',
            infoText:
                'Denna projektöversikt är inte filtrerad på den valda byggnaden.',
        },
        sak: {
            actionButtonText: 'Översikt över ärende',
            subtitle: 'Uppföljning av ärende',
            title: 'Ärenden',
            noTickets: 'Inga ärenden',
            sakStatus: {
                Aktiv: 'Aktiv',
                Avsluttet: 'Avslutad',
                Sammenslått: 'Sammanslagna',
                Slettet: 'Raderad',
                Unknown: 'Okänd',
                Utsatt: 'Utsatt',
                'Venter på 3dje part': 'Väntar på tredje part',
                'Venter på kunde': 'Väntar  på kund',
                Påbörjad: 'Påbörjad',
                'Ej påbörjad': 'Ej påbörjad',
            },
        },
        leverandor: {
            title: 'Leverantör',
            subtitle: 'Leverantör',
            assignedToMe: 'Tilldelad mig',
            underAssessment: 'Under bedömning',
            completed: 'Slutförd',
            rejected: 'Avvisad',
            actionButtonText: 'Leverantörsformulär',
        },
    },
    general: {
        backToTop: 'Tillbaka till toppen',
        by: 'av',
        cancel: 'Avbryt',
        charactersRemaining: '{{count}} tecken kvar',
        clear: 'Tömma',
        clearList: 'Tömma listan',
        clearSelection: 'Ta bort valet',
        close: 'Stänga',
        confirm: 'Ja',
        contextSelectorSearchField: 'Sök efter byggnadsavdelning',
        contextSelectorHint:
            "Lägg till byggnadsavdelning i listan 'Mina byggnader'",
        days_0: 'dag',
        days: 'dagar',
        decline: 'Nej',
        delete: 'Ta bort',
        deleteYes: 'Ja, ta bort',
        details: 'Detaljer',
        download: 'Ladda ner',
        draft: 'Förslag',
        edit: 'Redigera',
        emptyList: 'Listan är tom',
        error: {
            title: 'Fel',
            message: 'Ett fel uppstod.\nVänligen försök igen senare.',
            messageWithDetails:
                'Ett fel uppstod:\n{{errorMessage}}.\nVänligen försök igen senare.',
            apiErrorTitle: 'Felmeddelanden:',
            apiErorTitle_1: 'Felmeddelande:',
            apiError:
                'Ett fel uppstod vid hämtning av data. Utvecklingsteamet har blivit meddelat. Vi ber om ursäkt för besväret.',
            reloadPage: 'Ladda om sidan',
        },

        expired: 'Utgånget',
        expiryTime: {
            expired: '(Har löpt ut)',
            expires_within_6m: '(6 mndr)',
            expires_within_1y: '(1. år)',
            expires_within_2y: '(2 år)',
            expires_within_3y: '(3 år)',
            expires_within_4y: '(4 år)',
        },
        links: 'Länkar',
        goBack: 'Gå tillbaka',
        goBackToFrontpage: 'Gå tillbaka till framsidan',
        loading: 'Ladda...',
        menu: 'Meny',
        month: 'Månad',
        month_0: 'Jan',
        month_1: 'Feb',
        month_2: 'Mar',
        month_3: 'Apr',
        month_4: 'Mai',
        month_5: 'Jun',
        month_6: 'Jul',
        month_7: 'Aug',
        month_8: 'Sep',
        month_9: 'Okt',
        month_10: 'Nov',
        month_11: 'Dec',
        // tslint:disable-next-line: max-line-length
        noIe: 'Vi är ledsna, men den här funktionen stöds inte i Internet Explorer. Vi rekommenderar att du använder Google Chrome eller webbläsaren Mozilla Firefox.',
        name: 'Namn',
        of: 'av',
        open: 'öppna',
        pageNotFound: 'Hittade inte sidan',
        preview: 'Förhandsvis',
        previewDownload: 'FÖRHANDSVISNING / LADDA NER',
        publish: 'Publicera',
        readMore: 'Läs mer',
        reload: 'Ladda om',
        reset: 'Återställa',
        revert: 'Återställ',
        save: 'Spara',
        saveAsDraft: 'Spara som utkast',
        saved: 'Lagring lyckades',
        saving: 'Sparar...',
        savingError: 'Fel när det skulle sparas',
        show: 'vis',
        showAll: 'Visa alla',
        submit: 'Skicka in',
        sum: 'Belopp',
        updating: 'Uppdaterar...',
        unknown: 'Okänd',
        wrote: 'skrev',
    },
    languageName: 'Svensk',
    report: {
        error: 'Det gick inte att läsa in rapporter.',
        name: {
            ArealOgKontrakt: 'Areal och kontrakter',
            Kundereskonto: 'Kundkonto',
            Prosjekt: 'Projekt',
            Regnskap: 'Bokföring',
        },
        open: 'öppna',
        report: 'Rapport',
        title: 'Rapporter',
    },
    tables: {
        antallTreff_one: '{{count}} träff',
        antallTreff: '{{count}} träffar',
        body: {
            noMatch: 'Tyvärr, vi hittade inga resultat',
            toolTip: 'Sortera',
            toolTipFor: 'Sortera på ',
        },
        pagination: {
            displayRows: 'av',
            next: 'Nästa sida',
            previous: 'Sista sidan',
            rowsPerPage: 'Rader per sida:',
        },
        toolbar: {
            downloadCsv: 'Ladda ner CSV',
            filterTable: 'Filtrera tabell',
            print: 'Skriva ut',
            search: 'Sök',
            viewColumns: 'Visa kolumner',
        },
        filter: {
            all: 'Alla',
            reset: 'Återställa',
            title: 'FILTER',
        },
        viewColumns: {
            title: 'Visa kolumner',
            titleAria: 'Visa/dölj tabellkolumnen',
        },
        selectedRows: {
            delete: 'Radera',
            deleteAria: 'Radera vald rad',
            text: 'rad(er) markerade',
        },
        labelRowsPerPage: 'Rader per sida:',
    },
    validator: {
        email: 'Giltig e-postadress krävs!',
        required: 'Fältet är obligatoriskt!',
    },
    sustainability: {
        prosjektAvfall: {
            title: 'Hållbarhet i projekter',
            description:
                'Denna rapport visar information om avslutade projekt inom given period. Data för enskilda projekt listas i tabellen.',
            fromDate: 'Avslutat, från datum',
            toDate: 'Avslutat, till datum',
            reset: 'Återställ till senaste kvartal',
            uploadRapport: 'Ladda upp slutrapport manuellt',
            projectLabel: 'Välj projekt',
            projectWarning:
                'Projekt har redan en slutrapport, denna kommer att skrivas över av ny slutrapport.',
            selectFile: 'Välj fil',
            uploadRapportSuccess:
                'Slutrapporten har laddats upp och analyseras.',
            sluttrapportLabel: 'Slutrapport',
            lastOppRapport: 'Ladda upp slutrapport',
            uploadKlimagass: 'Ange växthusgasutsläpp manuellt',
            lagreKlimagass: 'Spara växthusgasutsläpp',
            updateKlimagassSuccess: 'Växthusgasutsläpp uppdaterat',
            summary: 'Sammanfattning',
            antallProsjekter: 'Antal projekt',
            antallProsjekterMedRapport: 'Antal projekt med slutrapport',
            totalAvfall: 'Totalt avfall',
            sorteringsgrad: 'Sorteringsgrad',
            tableTitle: 'Projekt',
            prosjektnummer: 'Nummer',
            prosjekttype: 'Typ',
            prosjektnavn: 'Namn',
            region: 'Region',
            byggtype: 'Fastighetstyp',
            bygg: 'Fastighet',
            prosjektleder: 'Projektledare',
            klimagassberegning: 'Beräknad klimatgasutsläpp',
            klimagassRelevant: 'Klimatgasberäkning relevant',
            klimagassRelevantHint:
                'Projektledarens svar vid start: Är en klimatgasberäkning (Reduzer el. likn., A1–A5 enligt NS 3720:2018) relevant för projektet?',
            klimagassForklaring: 'Motivering (om nej)',
            relevantJa: 'Ja',
            relevantNei: 'Nej',
            lesMer: 'Läs mer',
            prosjektSum: 'Avfallsvolym',
            document: 'Slutrapport',
            documentTooltip: 'Visa slutrapport',
            emptyTable: 'Hittade inga avslutade projekt',
            sortert: 'Totalt sorterat',
            usortert: 'Totalt osorterat',
            sum: 'Summa',
            sorteringHeader: 'Sortering',
            avfallTypeHeader: 'Varugrupp',
            beskrivelseHeader: 'Beskrivning',
            transporterHeader: 'Antal transporter',
            volumHeader: 'Avfallsvolym',
            volumAndelHeader: 'Andel',
            analyzeAction: 'Analysera rapporten igen',
            analyzeWarning:
                'Tidigare avfall för projektet kommer att skrivas över',
            editAction: 'Redigera avfallsposter manuellt',
            addRow: 'Lägg till rad',
            updateSuccess: 'Avfall uppdaterat',
            error: {
                validation: 'Vänligen rätta felen före lagring',
                invalidMengde: 'Mängd måste vara större än eller lika med 0',
                invalidKlimagassberegning:
                    'Klimatgasberäkning måste vara större än eller lika med 0',
                typeRequired: 'Avfallstyp krävs',
            },
        },
    },
    reportMapping: {
        menu: {
            title: 'Energinet rapportkoppling',
        },
        breadcrumbs: {
            reportMapping: 'Energinet rapportkoppling',
            documentation: 'Dokumentation',
        },
        documentation: {
            title: 'Dokumentation',
            openExternal: 'Öppna extern länk till Confluence-sida',
            backButton: 'Tillbaka till rapportkoppling',
            viewInConfluence: 'Öppna dokumentationen i Confluence',
        },
        mappingAdd: {
            title: 'Ny koppling',
            titleMappingFor: 'Ny koppling för rapport:',
            selectReport: 'Välj rapport',
            selectBuilding: 'Välj byggnad',
            selectCustomer: 'Välj kund',
            selectReportType: 'Välj rapporttyp',
            searchBuildings: 'Sök efter byggnader...',
            searchCustomers: 'Sök efter kunder...',
            searchReports: 'Sök efter rapporter...',
            save: 'Spara',
        },
        mappingEdit: {
            title: 'Redigera koppling',
            titleMappingFor: 'Redigera koppling för rapport:',
            save: 'Uppdatera',
        },
        mappingTransfer: {
            title: 'Överför rapport',
            titleMappingFor: 'Överför rapport:',
            transfer: 'Överför',
            success:
                'Rapporten överfördes och synkroniserades framgångsrikt med andra system.',
            disclaimer:
                'OBS! Vid lagring av rapporten kommer den att synkroniseras med andra system. Detta kan ta upp till 3 minuter. Vänligen stäng inte fönstret förrän synkroniseringen är klar.',
            disclaimerNightly:
                'Om du inte vill överföra nu kommer rapporterna att överföras vid nattlig synkronisering',
        },
        mappingTable: {
            type: 'Typ',
            report: 'Rapport',
            building: 'Byggnad',
            customer: 'Kund',
            actions: 'Tiltak',
            filterByStatus: 'Filtrera efter status',
            all: 'Alla',
            mapped: 'Kopplad',
            unmapped: 'Inte kopplad',
        },
        mappingDelete: {
            title: 'Ta bort koppling',
            confirmationText:
                'Är du säker på att du vill ta bort denna koppling?',
        },
        mappingsSummary: {
            totalMappings: 'Rapporter',
            withBygg: 'Kopplad till byggnad',
            withKunde: 'Kopplad till byggnad och kund',
        },
        error: {
            noAvailableReports:
                'Inga tillgängliga rapporter att koppla till för den valda byggnaden.',
            saveFailed: 'Kunde inte spara rapporten. Försök igen.',
            transferFailed:
                'Rapporten sparades, men synkronisering med andra system misslyckades. Synkroniseringen kommer att försökas igen automatiskt.',
        },
        reportType: {
            Unknown: 'Okänd',
            Energy: 'Tidsseriedrapport om energibärare',
            Waste: 'Avfallsrapport om fraktioner eller fraktionsgrupper',
            MonthlyEnergy: 'Månadsrapport om energibärare',
            Water: 'Vattenrapport om förbrukning senaste 24 månaderna',
            AdjustedEnergy:
                'Graddagskorrigerad energirapport, för i år relativt till senaste 4 åren',
            MonthlyCustomerEnergy:
                'Månadsrapport om energibärare (endast för kundportalen)',
            CustomerSpecificEnergy: 'Energirapport specifik för kund',
        },
    },
    devRoleSelector: {
        label: 'Vald testroll',
        heading: 'Välj testroll',
        original: 'Original (riktig roll)',
        forvalterKontor: 'Förvaltare – Kontor (Asbjørn)',
        forvalterKjopesenter: 'Förvaltare – Köpcenter (Carl Christian)',
        okonomi: 'Ekonomi (Valarmathy)',
        okonomiQA: 'Ekonomi QA (Solrunn)',
        prosjektleder: 'Projektledare/Projektägare (Henriette)',
    },
};
